export default __webpack_public_path__ + "static/media/NorthCamp.d9cb2abd.png";